import React, { useState } from "react";
import './Upload.css';
import UploadDataService from "../../services/upload.service";
import SignUpDataService from "../../services/signup.service";
import Updated from "../Messages/Updated";
import { Card, CardHeader, CardText, CardBody, Row, Col } from "reactstrap";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import Icon from 'supercons';

class Upload extends React.Component{

  constructor(props) {
    const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
    let userid = 0;
    if(isLoggedIn)
    {
    userid = window.localStorage.getItem("userid");

    }
  
    super(props);
    this.state = {
      description: "",
      selectedFile: null,
      userid: userid,
      downloads: [],
      downloadsAll: [],
      stage: 0,
      imgCount : 0,
      modalShow : false,
      displayImage : 'cupid.png'
    };
  }

  handleShow = (name) => {
    this.setState({modalShow: true});
    this.setState({displayImage: name});
  }

  handleClose = () => {
    this.setState({modalShow: false});
  }

  handleSelectedFile = e => {
    e.preventDefault();
    this.setState({
      selectedFile: e.target.files[0]
    });
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleUpload = event => {

    event.preventDefault();
    this.setState({ stage: 0 });

    
    if(this.state.imgCount >= 4)
    {
      this.setState({ stage: 3 });
      return;

    }


    if(this.state.description == '' || this.state.selectedFile == null)
    return;

    //description should be unique
    if(this.state.downloadsAll != [] && this.state.downloadsAll.length > 0)
    {
      
    if( this.state.downloadsAll[0].includes(this.state.description))
    {
      this.setState({ stage: 6 });
      return;
    }


    }


    const data = new FormData(event.target);
    data.append("file", this.state.selectedFile, this.state.description);

    UploadDataService.createAWS(data,this.state.userid)
    .then(response => {

      if(response.data != '')
      {
      this.setState({ stage: 1 }) 
      this.setState({ description: '' });
      this.setState({selectedFile: null });
      document.getElementById("fileUploader").value = "";
      //this.componentDidMount();

      let data = {
        upload: 1
      };

      SignUpDataService.update(this.state.userid, data)
      .then(res => {
        this.componentDidMount();
      });

      }
      else
      {
        this.setState({ stage: 2 }) 
        this.setState({ description: '' })
        this.setState({selectedFile: '' });
      }

    });



  };


  async componentDidMount() {

    this.setState({
      downloads: []
    });

    let downloadList = [];

    await UploadDataService.downloadAll()
    .then(res => {
      if(res.data != '')
      {
        res.data.map(val => {
          downloadList.push(val.filename);

        });

        this.setState({
          downloadsAll: [
            downloadList
          ]
        });

       

      }

    });

    let arrayList = [];
   await UploadDataService.download(this.state.userid)
    .then(response => {
      if(response.data != '')
        {
          this.setState({imgCount : response.data.length})

          response.data.map(val  => {

            let data = {
              id: val.id,
              fileLink: val.fileLink,
              userid: val.userid,
              filename: val.filename

            }

            arrayList.push(data);

          }
            
            );

          

          this.setState({
            downloads: [
            arrayList
            ]
          });

        }

    })
    .catch(e => {
      console.log(e);
    });
    

  }

  validateForm = () => {
    return this.state.selectedFile != null &&  this.state.description != '';
  }

onDeleteImage = async (e, link) =>{

  e.preventDefault();

    this.setState({ stage: 0 });

   await UploadDataService.delete(parseInt(e.target.name))
    .then(res => {
      if(res.data != '3')
      {
     
        UploadDataService.deleteAWS(link)
        .then(res => {


        });


        UploadDataService.download(this.state.userid)
        .then(response => {
            if(response.data == '')
            {
              //if count is zero , reset upload flag
        let data = {
          upload: 0
        };
        SignUpDataService.update(this.state.userid, data)
        .then(res => {
          
        });

            }

        });
       
      this.setState({ stage: 4 });
      this.componentDidMount();
   
      }
    });

    
}

render(){

  return (
    <div className="container col-md-10">
      <Row>

      <Modal show={this.state.modalShow} onHide={this.handleClose}>
        <Modal.Header closeButton>
        <Button variant="secondary" onClick={this.handleClose}>
            Close
          </Button>
        </Modal.Header>
        <Modal.Body><img width="400" src={this.state.displayImage} /></Modal.Body>
        <Modal.Footer>
         
        </Modal.Footer>
      </Modal>
      </Row>
      <Row>
      {this.state.stage == 1 ? <Updated Color={'accept-color'}  Message={'Succesfully uploaded image'}/> : ''}
      {this.state.stage == 2 ? <Updated Color={'reject-color'}  Message={'Unable to uplaod image. Please Contact helpdesk.'}/> : ''}
      {this.state.stage == 3 ? <Updated Color={'reject-color'}  Message={'You can only upload a total of 4 images.'}/> : ''}
      {this.state.stage == 4 ? <Updated Color={'accept-color'}  Message={'Image deleted successfully'}/> : ''}
      {this.state.stage == 5 ? <Updated Color={'reject-color'}  Message={'Unable to delete image. Please Contact helpdesk.'}/> : ''}
      {this.state.stage == 6 ? <Updated Color={'reject-color'}  Message={'Description already taken. Please type another description.'}/> : ''}
      </Row>
      <Row>
      <div className="col-md-12 gallery">Photo Gallery</div>
      </Row>
      <hr/>
      <Row className="border-color">
       
         {this.state.downloads.map(dat => dat.map((fat,index) => (
              <div key={"key" + index} className="row col-md-3">
                <Col className="border-img" md="12">  
           <img width="220" onClick={() => this.handleShow(fat.fileLink)} src={fat.fileLink} key={index}  /> <br/>
            <label>{fat.filename}</label><br/>
            <button name={fat.id}  onClick={e => this.onDeleteImage(e, fat.filename)} type="submit" className="btn btn-danger">
            Delete Image
          </button>
     
          </Col>
          </div>
         )
         ))
       }

      </Row>
      <hr/>
      <Row>

        <Col md="6">
          <Card>
            <CardHeader className="p-3 mb-3 bg-info text-white">
              Upload a new Image
            </CardHeader>
            <CardBody>
              
                <form onSubmit={this.handleUpload}>
                  <div className="form-group">
                    <label htmlFor="description">Description:</label>
                    <input required maxLength="30"
                      type="text" value={this.state.description}
                      className="form-control"
                      name="description" 
                      onChange={this.onChange}
                      placeholder="Description"
                    />
                    <span>No special Characters other than space</span>
                  </div>

                  <div className="form-group">
                    <input
                      type="file"
                      name="" 
                      id="fileUploader" 
                      onChange={this.handleSelectedFile}
                    />
                  </div>
                  <button disabled={!this.validateForm()} type="submit" className="btn btn-primary">
                  <Icon glyph="photo" size={32} />  Upload
                  </button><br/>
                  <span>Only 4 images can be uploaded.</span>
                </form>
              
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

}

export default Upload;